// export const BASE_URL = 'http://localhost:3005';
// export const BASE_URL = 'https://fabro-hotels.onrender.com';
export const BASE_URL = 'https://bookinghotelbackend.staffin.cloud';






